import _styled from "@emotion/styled/base";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Breakpoint } from '@travel-frontend/core';
import { IconSsl } from '@travel-frontend/icons';
import { useTranslation } from 'next-i18next';
import { SslContainer } from '../../components/SslWidget/components/SslContainer.js';
import { SslWrapper } from '../../components/SslWidget/components/SslWrapper.js';
export const SslWidget = /*#__PURE__*/_styled(({
  ...restProps
}) => {
  const {
    t
  } = useTranslation('headerNew');
  return _jsx(SslWrapper, {
    ...restProps,
    children: _jsxs(SslContainer, {
      children: [_jsx(IconSsl, {
        fontScale: "small"
      }), _jsx(Breakpoint, {
        matches: ['md', 'lg', 'xl'],
        children: t('sslText')
      })]
    })
  });
}, process.env.NODE_ENV === "production" ? {
  target: "e1bi6ofk0"
} : {
  target: "e1bi6ofk0",
  label: "SslWidget"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZGV4LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVVHIiwiZmlsZSI6ImluZGV4LmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsganN4IGFzIF9qc3gsIGpzeHMgYXMgX2pzeHMgfSBmcm9tIFwiQGVtb3Rpb24vcmVhY3QvanN4LXJ1bnRpbWVcIjtcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IEJyZWFrcG9pbnQgfSBmcm9tICdAdHJhdmVsLWZyb250ZW5kL2NvcmUnO1xuaW1wb3J0IHsgSWNvblNzbCB9IGZyb20gJ0B0cmF2ZWwtZnJvbnRlbmQvaWNvbnMnO1xuaW1wb3J0IHsgdXNlVHJhbnNsYXRpb24gfSBmcm9tICduZXh0LWkxOG5leHQnO1xuaW1wb3J0IHsgU3NsQ29udGFpbmVyIH0gZnJvbSAnLi4vLi4vY29tcG9uZW50cy9Tc2xXaWRnZXQvY29tcG9uZW50cy9Tc2xDb250YWluZXIuanMnO1xuaW1wb3J0IHsgU3NsV3JhcHBlciB9IGZyb20gJy4uLy4uL2NvbXBvbmVudHMvU3NsV2lkZ2V0L2NvbXBvbmVudHMvU3NsV3JhcHBlci5qcyc7XG5leHBvcnQgY29uc3QgU3NsV2lkZ2V0ID0gc3R5bGVkKCh7IC4uLnJlc3RQcm9wcyB9KSA9PiB7XG4gICAgY29uc3QgeyB0IH0gPSB1c2VUcmFuc2xhdGlvbignaGVhZGVyTmV3Jyk7XG4gICAgcmV0dXJuIChfanN4KFNzbFdyYXBwZXIsIHsgLi4ucmVzdFByb3BzLCBjaGlsZHJlbjogX2pzeHMoU3NsQ29udGFpbmVyLCB7IGNoaWxkcmVuOiBbX2pzeChJY29uU3NsLCB7IGZvbnRTY2FsZTogXCJzbWFsbFwiIH0pLCBfanN4KEJyZWFrcG9pbnQsIHsgbWF0Y2hlczogWydtZCcsICdsZycsICd4bCddLCBjaGlsZHJlbjogdCgnc3NsVGV4dCcpIH0pXSB9KSB9KSk7XG59KSBgYDtcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPWluZGV4LmpzLm1hcCJdfQ== */");